import { render, staticRenderFns } from "./Parceiros.vue?vue&type=template&id=00820124"
import script from "./Parceiros.vue?vue&type=script&lang=js"
export * from "./Parceiros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports